<template>
  <div>
    <div v-if="loading" class="text-center bg-gray-200 p-4 rounded">
      <Loader />
    </div>

    <div v-else-if="contactLists.length" class="list list-spaced rounded">
      <div class="flex py-2 font-medium text-sm bg-gray-200 uppercase text-gray-600">
        <div class="flex-1 px-4">Name</div>
        <div class="pl-4 pr-20 mr-3">Subscriptions</div>
      </div>

      <ContactListLine
        v-for="line in contactLists"
        :key="line.uuid"
        :contact-list="line"
        @contact-list-edit="editContactList"
        @contact-list-delete="confirmDeleteContactList"
      />
    </div>

    <div v-else class="bg-gray-200 p-6 text-center rounded">No contact lists found.</div>

    <template v-if="$membershipHasPermissionTo('edit contact lists')">
      <portal v-if="contactList && isActionEdit" to="app-dialog">
        <ModalEdit :contact-list="contactList" @closed="resetAction" />
      </portal>
    </template>

    <template v-if="$membershipHasPermissionTo('edit projects')">
      <portal v-if="contactList && isActionDelete" to="app-dialog">
        <BaseDialogDelete
          danger
          :custom-classes="'max-w-md'"
          @closed="resetAction"
          @confirmed="$emit('contact-list-delete', contactList.id)"
        />
      </portal>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import ModalEdit from '@/components/ContactLists/ModalEdit.vue';
import ContactListLine from './ContactListLine.vue';

const ACTION_EDIT = 'edit';
const ACTION_DELETE = 'delete';

export default {
  components: {
    ContactListLine,
    ModalEdit,
  },

  props: {
    loading: Boolean,
    projectUuid: { type: String, required: true },
    contactLists: { type: Array, default: () => [] },
  },

  data: () => ({
    pending: false,
    action: null,
  }),

  computed: {
    ...mapGetters('ui/contactLists', ['contactList']),

    isActionEdit() {
      return this.action === ACTION_EDIT;
    },

    isActionDelete() {
      return this.action === ACTION_DELETE;
    },
  },

  methods: {
    ...mapMutations('ui/contactLists', ['setCurrent']),

    editContactList(contactList) {
      this.setCurrent(contactList.id);
      this.action = ACTION_EDIT;
    },

    confirmDeleteContactList(contactList) {
      this.setCurrent(contactList.id);
      this.action = ACTION_DELETE;
    },

    resetAction() {
      this.setCurrent(null);
      this.action = null;
    },
  },
};
</script>
